module.exports = __webpack_public_path__ + "img/75746.e7d5a6ec.svg";